import { render, staticRenderFns } from "./PersonalPerformance.vue?vue&type=template&id=645bf716&"
import script from "./PersonalPerformance.vue?vue&type=script&lang=js&"
export * from "./PersonalPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports